import Forma from './Forma';
import FormaCreate from './Create';
import FormaEmbed from './Embed';
import FormaUpdate from './Update';
import FormaDetail from './Detail';

export { Forma, FormaCreate, FormaEmbed, FormaUpdate, FormaDetail };
